import "styles/sections/reviews/SlideNavButton.scss";
import clsx from "clsx";

function SlideNavButton({
  slideNumber,
  slideLabel,
  currentSlideLabel,
  currentSlide,
  onSlideChange,
}: Props) {
  const isCurrentSlide = slideNumber === currentSlide;
  const slideInfo = slideLabel + " " + slideNumber;
  const currentInfo = isCurrentSlide ? ` (${currentSlideLabel})` : "";
  const info = slideInfo + currentInfo;

  return (
    <li className="slide-nav-item">
      <button
        className={clsx(
          "slide-nav-item__button",
          isCurrentSlide && "slide-nav-item__button--current"
        )}
        disabled={isCurrentSlide}
        onClick={() => onSlideChange(slideNumber)}
      >
        <span className="visually-hidden">{info}</span>
      </button>
    </li>
  );
}

type Props = {
  slideNumber: number;
  slideLabel: string;
  currentSlide: number;
  currentSlideLabel: string;
  onSlideChange: (slideNumber: number) => void;
};

export default SlideNavButton;
